import { useCallback } from 'react';

// Declare the Unity instance type
export const useUnityAPI = () => {
  const sendEventToUnity = useCallback((type: number, jsonData: string) => {
    try {
      if (typeof window !== 'undefined' && window.sendEventToUnity && typeof window.sendEventToUnity === 'function') {
        window.sendEventToUnity(type, jsonData);
      }
    } catch (error) {
      console.error('Error calling sendEventToUnity:', error);
    }
  }, []);

  return {
    sendEventToUnity,
  };
};
